import { render, staticRenderFns } from "./PurchaseConfirmation.vue?vue&type=template&id=305ec4be&"
import script from "./PurchaseConfirmation.vue?vue&type=script&lang=ts&"
export * from "./PurchaseConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports